//export const serverURL = "http://192.168.1.13:8321";
export const serverURL = "https://api.bqdv.atelierdelevaluation.fr";

